<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>
        Olá! Vamos começar a avaliação comportamental do seu gestor imediato?
      </h2>
    </div>

    <div>
      <h2>Analise os comportamentos do seu gestor imediato</h2>
      <p>
        Os comportamentos aparecerão na sua tela. Ao lado de cada um, aparecerá
        uma escala que vai de <span class="info--text">"Nunca"</span> a
        <span class="info--text">"Sempre"</span>.
      </p>
      <p class="info--text">
        Lembre-se! <br>
        Em unidades com 2 (dois) ou mais servidores em exercício, é garantido ao
        servidor o anonimato da sua avaliação, considerando que o gestor terá
        acesso somente à nota média das avaliações recebidas dos servidores da
        equipe.
      </p>
    </div>

    <div>
      <h2>Analise a frequência dos comportamentos do seu gestor imediato</h2>
      <p>
        Clique na estrela que representa a frequência que o seu gestor
        apresentou o comportamento indicado durante os últimos doze meses.
      </p>
    </div>

    <div>
      <h2>Importante!</h2>
      <p class="info--text">
        Lembre-se! Essa avaliação ajudará a direcionar a trilha de
        desenvolvimento do seu gestor imediato.
      </p>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../BaseTutorial';

export default {
  name: 'TutorialAvaliacaoGestor',

  components: { BaseTutorial },

  data() {
    return {
      steps: ['Introdução', 'Comportamentos', 'Frequência dos comportamentos', 'Importante'],
    };
  },
};
</script>
